module.exports = __webpack_public_path__ + "kudos_48.svg?1403e15aed37d632a39e5a994cb2b7a0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_48.svg
// module id = 148
// module chunks = 0